module.exports = __webpack_public_path__ + "static/media/产品优势-低代码应用开发平台.bb10337f.jpg";